import createReducer from './createReducer';
import { SELECT_GIFT_PRODUCT, SAVE_GIFT_DATA, EDIT_GIFT, PURCHASE_GIFT_FAILURE, PURCHASE_GIFT_SUCCESS } from '../actions/gifts';

const initialState = {
  showPaymentForm: false
};
const handlers = {};

handlers[SELECT_GIFT_PRODUCT] = (state, { selectedProductId }) => ({
  ...state,
  selectedProduct: state.giftProducts && state.giftProducts.find(product => product._id === selectedProductId)
});

handlers[SAVE_GIFT_DATA] = (state, { savedGiftData, showPaymentForm }) => ({
  ...state,
  savedGiftData,
  showPaymentForm
});

handlers[EDIT_GIFT] = (state, { showPaymentForm }) => ({
  ...state,
  showPaymentForm
});

handlers[PURCHASE_GIFT_FAILURE] = (state, { message }) => ({
  ...state,
  error: message
});

handlers[PURCHASE_GIFT_SUCCESS] = state => ({
  ...state,
  showPaymentForm: false,
  purchaseSuccess: true
});

export default createReducer(handlers, initialState);
